<template>
  <div class="fourth-shape-hero-section" v-show="startAnimitionShapeFour">
    <!-- Review Card -->
    <div class="review-card" :class="{ 'appear': showReviewCard, 'hide': hideReviewCard }" v-if="showReviewCard">
      <!-- Card Content -->
      <div class="review-card-content">
        <!-- Title -->
        <div class="review-title">مراجعة التقييمات</div>
        
        <!-- Description -->
        <div class="review-description">
          نقوم الآن بمراجعة دقيقة للتقييمات للتأكد من جودتها ومواءمتها للاحتياج. اقتربنا من عرض النتائج
        </div>
        
        <!-- Progress Section -->
        <div class="progress-section">
          
          <!-- Progress Bar -->
          <div class="progress-bar">
            <div class="progress-bar-fill" :class="{ 'fill-progress': startProgressFill }"></div>
          </div>

          <!-- Percentage -->
          <div class="progress-percentage">%80</div>

        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, computed, watch } from 'vue'
const props = defineProps({
  startAnimitionShapeFour: {
        type: Boolean,
        required: true
    }
})
const startAnimationRun = ref(false)

const startAnimitionShapeFour = computed(() => props.startAnimitionShapeFour)
watch(startAnimitionShapeFour, (newVal) => {
    if(newVal){
      startAnimationSequence()
    }else{
      startAnimationRun.value = false
    }
})
// Animation states
const showReviewCard = ref(false)
const startProgressFill = ref(false)
const hideReviewCard = ref(true)

// Animation sequence function
const startAnimationSequence = async () => {
  if(!startAnimitionShapeFour.value || startAnimationRun.value){
    return
  }
  startAnimationRun.value = true
  // Step 1: Show review card with appear animation
  await new Promise(resolve => setTimeout(resolve, 500))
  showReviewCard.value = true
  hideReviewCard.value = false
  
  // Step 2: Wait for card to fully appear (0.8s)
  await new Promise(resolve => setTimeout(resolve, 800))
  
  // Step 3: Start progress fill animation
  startProgressFill.value = true
  
  
  // Step 5: Wait 1 second after progress completion
  await new Promise(resolve => setTimeout(resolve, 1500))
  
  // Step 6: Hide the element
  hideReviewCard.value = true
  
  // Step 7: Wait for hide animation to complete (0.5s)
  await new Promise(resolve => setTimeout(resolve, 500))
  
  // Step 8: Reset to initial state
  await resetToInitialState()
  
  // Step 9: Restart animation cycle after 1 second
  await new Promise(resolve => setTimeout(resolve, 2000))
  startAnimationSequence()
}

// Function to reset all elements to initial state
const resetToInitialState = async () => {
  showReviewCard.value = false
  startProgressFill.value = false
  hideReviewCard.value = false
  // Wait for reset to complete
  await new Promise(resolve => setTimeout(resolve, 300))
}

// Start animation when component mounts
onMounted(() => {
  // Start animation sequence after a short delay
  setTimeout(() => {
    startAnimationSequence()
  }, 500)
})

// Expose functions to parent component
defineExpose({
  showReviewCard,
  startProgressFill,
  hideReviewCard,
  startAnimationSequence,
  resetToInitialState
})
</script>

<style scoped>
/* Container */
.fourth-shape-hero-section {
  width: 340px;
  height: 340px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

/* Review Card */
.review-card {
  width: 191px;
  height: 159px;
  background: #FFFFFF;
  border-radius: 11.88px;
  opacity: 0;
  transition: all 0.5s ease-in-out;
  border: 1px solid rgba(238, 238, 238, 0.933333);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.review-card.appear {
  opacity: 1;
  animation: reviewCardAppear 0.8s ease-out;
}

.review-card.hide {
  animation: reviewCardHide 0.5s ease-in forwards;
}

@keyframes reviewCardAppear {
  0% {
    opacity: 0;
    transform: scale(0.8) translateY(20px);
  }
  50% {
    opacity: 0.8;
    transform: scale(1.05) translateY(-5px);
  }
  100% {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

@keyframes reviewCardHide {
  0% {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
  100% {
    opacity: 0;
    transform: scale(0.8) translateY(-20px);
  }
}

/* Card Content */
.review-card-content {
  padding: 8px 6px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

/* Title */
.review-title {
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  text-align: start;
  color: #000000;
  margin-block: 14px;
}

/* Description */
.review-description {
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  text-align: start;
  color: #000000;
  margin-bottom: 22px;
  width: 179px;
  height: 54px;
  display: flex;
  align-items: center;
}

/* Progress Section */
.progress-section {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 160px;
  height: 18px;
}

/* Percentage */
.progress-percentage {
  width: 26px;
  height: 18px;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  color: #000000;
}

/* Progress Bar */
.progress-bar {
  width: 124px;
  height: 12px;
  background: rgba(238, 238, 238, 0.933333);
  border-radius: 8px;
  position: relative;
  overflow: hidden;
}

/* Progress Bar Fill */
.progress-bar-fill {
  position: absolute;
  width: 0px;
  left: 0px;
  top: 0;
  bottom: 0;
  background: #5854FF;
  border-radius: 0px 8px 8px 0px;
  transition: width 2s ease-out;
}

.progress-bar-fill.fill-progress {
  width: 105px;
}
</style>
